import { Input } from '@web/components/atoms/Input'
import { CustomFieldComponentProps } from '../CustomFieldComponent'
import { Field } from '@web/components/atoms/Field'
import { ExtraFieldType } from '@web/graphql-types'

const TextInput = ({
  isRequired,
  name,
  label,
  placeholder,
  fieldDescription,
  onChange,
  value,
  id,
  hideLabel,
  type,
}: CustomFieldComponentProps) => {
  return (
    <Field
      label={hideLabel ? '' : label}
      required={isRequired}
      htmlFor={`custom-field-${name}`}
      helperText={fieldDescription}
    >
      <Input
        id={`custom-field-${name}`}
        type={type === ExtraFieldType.Email ? 'email' : 'text'}
        name={name}
        onChange={(e) => {
          onChange?.({
            target: {
              name: id,
              value: e.target.value,
            },
          } as React.ChangeEvent<HTMLInputElement>)
        }}
        value={value ?? ''}
        placeholder={placeholder ?? ''}
      />
    </Field>
  )
}

export default TextInput
